<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <button mat-icon-button disabled></button>
    <button *ngIf="node.selected" mat-flat-button (click)="folderClick(node)" color="primary">{{node.displayName}}</button>
    <div *ngIf="!node.selected" style="cursor: pointer;" (click)="folderClick(node)">{{node.displayName}}</div>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node; when hasChild" matTreeNodePadding style="min-height: 20px;">
    <button mat-icon-button matTreeNodeToggle>
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <button *ngIf="node.selected && !node.isCaseRootNode" mat-flat-button (click)="folderClick(node)" color="primary">{{node.displayName}}</button>
    <div *ngIf="!node.selected && !node.isCaseRootNode" style="cursor: pointer;" (click)="folderClick(node)">{{node.displayName}}</div>
    <div *ngIf="node.isCaseRootNode" style="cursor: default;">{{node.displayName}}</div>
    <mat-progress-bar *ngIf="node.isLoading" mode="indeterminate" class="example-tree-progress-bar">
    </mat-progress-bar>
  </mat-tree-node>
</mat-tree>
